import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainLayout from "Layouts/Main";
import "./styles.scss";
import assets from "../../../../Assets";
import { useDispatch } from "react-redux";
import { fetchIndividualQuoteReq } from "../../../../Redux/Slices/chooseKgSlice";

const QuoteRequestDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [purchaseRequestData, setPurchaseRequestData] = useState([]);

  useEffect(() => {
    dispatch(
      fetchIndividualQuoteReq({
        data: { id },
        callBack: (value) => {
          setPurchaseRequestData(value?.data || []);
        },
      })
    );
  }, [dispatch, id]);

  const headerData = purchaseRequestData[0]; // for shared info

  return (
    <MainLayout pageName="Enquires">
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Quote Request</p>
      </div>

      <div className="PurchaseRequestDetailsContainer">
        {/* Header */}
        <div className="PurchaseRequestDetailsHeader">
          <h2>Quote Request Details</h2>
          <p>Inquiry ID: #{headerData?.inquiryId || "-"}</p>
        </div>

        <hr style={{ backgroundColor: "#E6E6E6" }} />

        <p className="purchaseRequestSubheading">Product Details</p>

        {/* Product Details */}
        <div className="ProductDetails">
          {purchaseRequestData.length ? (
            purchaseRequestData.map((item) => (
              <div className="ProductCard" key={item.id}>
                <div className="ProductInfo">
                  <h3>{item.product_name || "-"}</h3>
                  <p>Product ID&nbsp;:&nbsp;{item?.productId || "-"}</p>
                  <p>
                    Quantity Requested&nbsp;:&nbsp;
                    {item.quantity || "-"}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p>No products found</p>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default QuoteRequestDetails;
